
<template>
	<div :class="shown ? 'loading-container pt-4 show' : 'loading-container pt-4'">
		<div>
			<div class="icon-ct">
                <loading />
            </div>
		</div>
	</div>
</template>
<script>
import Loading from '@/assets/img/loading';
export default {
    props: [
        "shown"
    ],
    components: {
        Loading
    }
}
</script>